import React, { useCallback, useState, useEffect, useRef } from 'react';
import style from './InspectionDetail.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import InspectionGraphBox from '../../../../components/box/InspectionGraphBox';

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import Skeleton from '@mui/material/Skeleton';

import arrowUp from '../../../../images/common/i_arrow_up.svg';
import arrowDown from '../../../../images/common/i_arrow_down.svg';


const InspectionDetail = () => {

    const navigate = useNavigate();
    const location = useLocation();
    
    const [subType, setSubType] = React.useState("detail");
    const [open, setOpen] = useState(false);
    const [mediInfo, setMediInfo] = useState();
    const [clnicExamRsltInfo, setClnicExamRsltInfo] = useState({});
    const [clnicExamRsltList, setClnicExamRsltList] = useState([]);
    const [targetExamRsltList, setTargetExamRsltList] = useState({
        title : "",
        data : [],
        range : []
    }); //주요 타겟 검사 결과

    const [isLoading, setIsLoading] = useState(false); // 상태 추가
    const { hsptlCd = "", patntId = "", deptCd = "", testDt = "", rcptNo } = location.state || {};

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    useEffect(() => {
        getClnicInfo();
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    const getClnicInfo = useCallback(async () => {

        setIsLoading(true);

        let usrHsptlMapId = "";

        loginUser.usrHsptlMap.map(item=>{
            if(item.cnncHsptlCd === hsptlCd){
                usrHsptlMapId = item.usrHsptlMapId;
            }
        })

        const url = "/hsptl/retrieveHsptlClnicExamRsltInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            hsptlCd         : hsptlCd   , 
            patntId         : patntId   ,
            deptCd          : deptCd    ,
            testDt          : testDt    ,
            usrHsptlMapId   : usrHsptlMapId
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                
                setMediInfo({...mediInfo});
                setClnicExamRsltInfo(mediInfo.clnicExamRsltInfo);
                setClnicExamRsltList(mediInfo.clnicExamRsltList);

                console.log("mediInfo.clnicExamRsltList : ", mediInfo.clnicExamRsltList)
                   
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })
        .finally(() => {
            setIsLoading(false);
        });

    }, [navigate]);


    const saveFavorite = useCallback(async (exmnRsltId) => {

        let usrHsptlMapId = "";

        loginUser.usrHsptlMap.map(item=>{
            if(item.cnncHsptlCd === hsptlCd){
                usrHsptlMapId = item.usrHsptlMapId;
            }
        })

        const url = "/hsptl/saveHsptlExamRsltBkmkInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            usrHsptlMapId   : usrHsptlMapId,
            exmnRsltId      : exmnRsltId,
            testDt          : testDt
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
            , noLoading: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
             
                setClnicExamRsltList((prevList) => {
                    return prevList.map((item) => {
                        if (item.examRsltId === exmnRsltId) {
                            return {
                            ...item,
                            exmnRsltId: item.exmnRsltId === 0 ? item.examRsltId : 0,
                            };
                        }
                        return item;
                    });
                });

            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })

    }, []);



    // 그래프에 보여줄 데이터 조회
    const retrieveTargetExamRsltList = useCallback(async (title, range, hsptlCd, deptCd, prscrptnTestCd) => {

        const url = "/mypage/retrieveTargetExamRsltList";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
        }


        await axiosApi.post(url, {hsptlCd : hsptlCd, deptCd:deptCd, prscrptnTestCd : prscrptnTestCd}, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setTargetExamRsltList((prev) => ({ ...prev, title: title, range: range, data:res.data.result.targetExamRsltList }));
                handleClickOpenGraph();
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("타겟 주요검사 결과과 호출 중 오류  : ", err);
        })

    }, []);

    //그래프 오픈
    const handleClickOpenGraph = () => {
        setOpen(true);
    }


    const [abnormalDataSwitch, setAbnormalDataSwitch] = useState(false)
    const handleSwitchChange = (event) => {
        const checked = event.target.checked;
        setAbnormalDataSwitch(checked);
    };

    
    return (
        <>
            <HeadSub title="검사 상세"/>
            
            <div id="sub-content">     
                <div className='inner-wrap' data-bg-color="white" data-pad="normal">
                    
                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>기본정보</h2>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li>
                                        <p>검사일자</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="80px" height={20} />
                                        ) : (
                                        <span>{clnicExamRsltInfo.testDt}</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>진료과</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="80px" height={20} />
                                        ) : (
                                        <span>{clnicExamRsltInfo.clnicDeptNm}</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>의료진</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="60px" height={20} />
                                        ) : (
                                        <span>{clnicExamRsltInfo.doctrNm}</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>검사 건수</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="40px" height={20} />
                                        ) : (
                                        <span>{clnicExamRsltInfo.totalCount}건</span>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>검사 정보</h2>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inspection-inform"]}>
                                <ul>
                                    {isLoading ? (
                                            <div style={{display:'flex', gap:'10px', flexWrap:'wrap'}}>
                                                <Skeleton variant="rectangular" width="80px" height={23} style={{borderRadius:'20px'}} />
                                                <Skeleton variant="rectangular" width="80px" height={23} style={{borderRadius:'20px'}} />
                                                <Skeleton variant="rectangular" width="80px" height={23} style={{borderRadius:'20px'}} />
                                            </div>
                                        ) : (
                                        (() => {
                                            const testCategories = clnicExamRsltInfo.prscrptnTestCtgrNm || '';
                                            const testCategoryArray = testCategories.split(',').map(item => item.trim());
                                            return testCategoryArray.map((item, index) => (
                                                <li key={index}>
                                                    <span>{item} 검사</span> {/* 여기서 item 값을 실제로 출력 */}
                                                </li>
                                            ));
                                        })()
                                         
                                    )}                               
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>검사 결과</h2>
                            <Box sx={{ display: "flex" }} className={style["swich-btn-btn"]}>
                                <Box className="mask-box">
                                    <Box className="mask" style={{ transform: `translateX(${subType === "detail" ? 0 : "var(--sp-wid-86)"})`}}/>
                                    <Button
                                        disableRipple
                                        variant="text"
                                        sx={{ color: subType === "detail" ? "#ffffff" : "var(--color-main-gray-10)"}}
                                        onClick={() => setSubType("detail")}
                                        className={subType === "detail" ? `${style.active}` : null}
                                    >
                                        자세히 보기
                                    </Button>
                                    <Button
                                        disableRipple
                                        variant="text"
                                        sx={{ color: subType === "simply" ? "#ffffff" : "var(--color-main-gray-10)"}}
                                        onClick={() => setSubType("simply")}
                                        className={subType === "simply" ? `${style.active}` : null}
                                        >
                                        간략히 보기
                                    </Button>
                                </Box>
                            </Box>
                        </div>
                        
                        <div className="swich-btn m-t-08">
                            <FormControlLabel control={<Switch size="small"/>} label="이상치만 보기" onChange={handleSwitchChange} />
                        </div>
                        
                    </div>
                </div>


                <div className='inner-wrap' data-pad="normal">


                {subType === "detail" ? (
                    // 자세히 보기 

                    <div className={style["detail-list-box"]} data-type="a">
                        <ul> 
                            {isLoading ? ( 
                                Array.from({ length: 5 }).map((_, idx) => (
                                        <li key={idx}>
                                            <div className={style["list-box"]}>
                                                <div className={style["top-head"]}>
                                                    <Skeleton variant="rectangular" width="60px" height={22} style={{borderRadius:'20px'}} />
                                                    <div className={style['btns-box']} >
                                                        <Skeleton variant="text" width={80} height={20}/>    
                                                    </div>
                                                </div>
                                                <div className={style["head"]}>
                                                    <Skeleton variant="text" width={120} height={24} />
                                                </div>
                                                <div className={style["value-box"]}>
                                                    <Skeleton variant="text" width={80} height={20} />
                                                </div>
                                                <p className={style["details-txt"]}>
                                                    <Skeleton variant="text" width={'100%'} height={20} />
                                                    <Skeleton variant="text" width={'100%'} height={20} />
                                                    <Skeleton variant="text" width={200} height={20} />
                                                </p>
                                            </div>
                                        </li>
                                    ))
                                ) : (
                            
                                clnicExamRsltList.filter((item, index) => {
                                    // 체크되었을 때는 isInRef === '0'인 것만
                                    if (abnormalDataSwitch) return item.isInRef === '0';
                                        return true;
                                    }).map((item, index) => {
                                    return (
                                        <li key={item.examRsltId}>
                                            <div className={style["list-box"]}>
                                                <div className={style["top-head"]}>
                                                    {item.isInRef === '-99' ? <span data-status=''></span> : item.isInRef === '0' ? <span data-status='strange'>이상</span>  : <span data-status="normal">정상</span>}
                                                    {/* <span data-status="normal">정상</span> */}
                                                    <div className={style['btns-box']}  onClick={(e) => e.stopPropagation()}>
                                                        <div className={style['favorites']}>
                                                            <div className="chkbox-custom" data-chkbox="favorites-btn">
                                                                <input type="checkbox" name="prscrptnTestCd" value={item.examRsltId} id={`favorites-btn-${index}`} checked={!!item.exmnRsltId} onChange={(e)=>{
                                                                    console.log("item.exmnRsltId : " , item.exmnRsltId)
                                                                    saveFavorite(item.examRsltId);
                                                                }}/>
                                                                <label htmlFor={`favorites-btn-${index}`}></label>
                                                            </div>
                                                        </div>
                                                        <button type="button" className={style['graph-more-btn']} onClick={() => {
                                                            retrieveTargetExamRsltList(item.testKorNm+" "+item.testEngNm, [item.refMin, item.refMax], item.hsptlCd, item.deptCd, item.prscrptnTestCd)
                                                        }}></button>    
                                                    </div>

                                                </div>
                                                <div className={style["head"]}>
                                                    <p>{item.testKorNm} <span>{item.testEngNm}</span></p>
                                                </div>
                                                <div className={style["value-box"]}>
                                                    {/* <strong>0.67mg/dl</strong> */}
                                                    <strong>{item.prscrptnTestRsltVal} {item.unit}</strong>
                                                    {/* <p className={style['compar-value']} data-status="up">(<span>0.12</span>)</p>   */}
                                                    {/* <p className={style['compar-value']} data-status="down">(<span>0.12</span>)</p>   */}

                                                    <p className={style['compar-value']} data-status={item.diffVal === 0 || !item.diffVal ? 'same' : item.diffVal > 0 ? 'up' : 'down'}>
                                                        (<span>{item.diffVal !== 0 ? item.diffVal : ""}</span>)
                                                    </p>                                                    
                                                </div>
                                                <p className={style["details-txt"]}>
                                                    {/* <span>급성 및 만성 신질환의 진단 및 치료 효과 모니터링을 위한 검사</span> */}
                                                    <span>{item.testKorDesc}</span>
                                                </p>
                                            </div>
                                        </li>

                                    )
                                })
                            
                            )}
                        </ul>   
                    </div>
                ):(
                    //간략히 보기
                    <div className={style["detail-list-box"]} data-type="b">
                        <ul> 

                            {
                                clnicExamRsltList.filter((item,index) => {
                                    // 체크되었을 때는 isInRef === '0'인 것만
                                    if (abnormalDataSwitch) return item.isInRef === '0';
                                        return true;
                                    }).map((item, index) => {
                                    return (
                                        <li key={item.examRsltId}>
                                            <div className ={style["list-box"]}>
                                                <div className={style['favorites']}>
                                                    <div className="chkbox-custom" data-chkbox="favorites-btn">
                                                        <input type="checkbox" name="prscrptnTestCd" value={item.examRsltId} id={`favorites-brief-btn-${index}`} checked={!!item.exmnRsltId} onChange={(evt)=>{
                                                            saveFavorite(item.examRsltId);
                                                        }}/>
                                                        <label htmlFor={`favorites-brief-btn-${index}`}></label>
                                                    </div>
                                                </div>

                                                <div className={style["mid-box"]}>
                                                    <p>{item.testKorNm} <span>{item.testEngNm}</span></p>
                                                    <div className={style["value-box"]}>
                                                            <p>결과 <span>{item.prscrptnTestRsltVal}</span></p>
                                                            <p>참고치 <span>{item.refVal}</span></p>
                                                    </div>
                                                </div>

                                                <div className={style["right-box"]}>
                                                    {/* <span data-status="strange">이상</span> */}
                                                    {item.isInRef === '-99' ? <span data-status=''></span> : item.isInRef === '0' ? <span data-status='strange'>이상</span>  : <span data-status="normal">정상</span>}
                                                    <button className={style['graph-more-btn']} onClick={() => {
                                                        retrieveTargetExamRsltList(item.testKorNm, [item.refMin, item.refMax], item.hsptlCd, item.deptCd, item.prscrptnTestCd)
                                                    }}></button>
                                                </div>
                                                
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>   
                    </div>
                )}


                </div>




                <BottomSheet
                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지
                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                         >
                            <InspectionGraphBox
                                    onClose={onDismiss}
                                    title={targetExamRsltList.title}
                                    data={targetExamRsltList.data}
                                    range={targetExamRsltList.range}
                                />
                </BottomSheet>


            </div>
            
        </>
    );
};
  
export default InspectionDetail;
